<template lang="pug">
  .app-container
    front-menu
    main.app-content
      section.hero.is-bold.is-fullheight.is-primary
        .hero-body
          .container
            .box.mt-5
              form.has-text-left
                .content
                  h1 Set a password

                <!--article.message.is-light-->
                  <!--.message-body-->
                    <!--| We don't sell your contact info to any third party.<br />-->

                .message.is-danger(v-if="error")
                    .message-body
                      | {{ error }}

                b-field.has-text-left(label="New password")
                  b-input#password(v-model="user.newPassword" type="password" size="is-medium")

                button#btn_save_profile.button.is-block.is-primary.is-medium.is-fullwidth(:class="{'is-loading': isLoading, 'is-disabled': isLoading, 'is-success': isSuccess}" @click.stop.prevent="save")
                  b-icon(v-if="isSuccess" icon="check")
                  span(v-else="")
                    | Save


</template>


<script>
  export default {
    name: 'SetPasswordPage',
    components: {
    },
    data() {
      return {
        error: null,
        user: {
          id: null,
          newPassword: '',
        },
        isLoading: false,
        isSuccess: false,
      }
    },
    created() {
    },

    methods: {
      onSubmit(evt) {

      },
      onClick(e) {
        e.preventDefault();
        this.$router.push('/')
      },


      save() {
        this.isLoading = true;
        this.$store.dispatch("saveUser", this.user).then(data => {
          this.$store.dispatch("setUser", data.user);
          this.$auth.user(data.user);
          this.isLoading = false;
          this.isSuccess = true;
          setTimeout(() => {
            this.isSuccess = false;
          }, 2500);
        });
      },

    }

  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SetPasswordPage.vue